import { ReactElement, memo } from 'react';
import { Typography } from '@mui/material';
import classNames from 'classnames';

import {
  DashboardVariantV2CarrierZoneSaturationHeaderLegendItemContainer,
  DashboardVariantV2CarrierZoneSaturationHeaderLegendDot,
} from './styles';

interface DashboardVariantV2CarrierZoneSaturationHeaderLegendItemProps {
  count: number;
  label: string;
  dotColor: string;
  withPulse?: boolean;
}

const DashboardVariantV2CarrierZoneSaturationHeaderLegendItem = ({
  count,
  label,
  dotColor,
  withPulse = false,
}: DashboardVariantV2CarrierZoneSaturationHeaderLegendItemProps): ReactElement => (
  <DashboardVariantV2CarrierZoneSaturationHeaderLegendItemContainer>
    <DashboardVariantV2CarrierZoneSaturationHeaderLegendDot
      dotColor={dotColor}
      className={classNames({ pulse: withPulse })}
    />

    <Typography variant="body2" fontWeight="bold">
      {count}
    </Typography>

    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </DashboardVariantV2CarrierZoneSaturationHeaderLegendItemContainer>
);

export default memo(DashboardVariantV2CarrierZoneSaturationHeaderLegendItem);
